import { SubscriptionMobileDeviceById } from 'graphql/generated/graphqlTypes';

export function generateMockSubscriptionMobileDeviceRegistered({
  mobileDeviceId = 'subscriptionMobileDeviceRegisteredMobileDeviceId',
  registrationDate = 'subscriptionMobileDeviceRegisteredRegistrationDate',
  visitorId = 'subscriptionMobileDeviceRegisteredVisitorId'
}: Partial<Omit<SubscriptionMobileDeviceById, '__typename'>>): SubscriptionMobileDeviceById {
  return {
    __typename: 'SubscriptionMobileDeviceById',
    mobileDeviceId,
    registrationDate,
    visitorId
  };
}
